<template>
  <div
    class="ratio-card"
    :class="variantClass"
  >
    <div class="ratio-card__accent" aria-hidden="true"></div>
    <div class="ratio-card__content">
      <div class="ratio-card__header">
        <div class="ratio-card__value-row">
          <span class="ratio-card__value">{{ mainText }}</span>
          <span v-if="chip" class="ratio-card__chip">{{ chip }}</span>
        </div>
        <v-icon v-if="featured" small class="ratio-card__star">fa-regular fa-star</v-icon>
      </div>
      <div class="ratio-card__footer">
        <p class="ratio-card__label">{{ subText }}</p>
        <v-tooltip v-if="tooltip && tooltip.text" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="ratio-card__info"
              v-bind="attrs"
              v-on="on"
            >
              fa-regular fa-circle-info
            </v-icon>
          </template>
          <span>{{ tooltip.text }}</span>
        </v-tooltip>
        <v-icon v-else small class="ratio-card__info">fa-regular fa-circle-info</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RatioCard",
  props: {
    chip: {
      type: String,
      default: '',
    },
    mainText: {
      type: String,
      default: '',
    },
    subText: {
      type: String,
      default: '',
    },
    appColor: {
      type: String,
      default: 'black',
    },
    featured: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
  },
  computed: {
    variantClass() {
      if (this.appColor === 'success') {
        return 'ratio-card--green';
      }
      if (this.appColor === 'error') {
        return 'ratio-card--red';
      }
      return 'ratio-card--neutral';
    },
  },
};
</script>

<style lang="scss" scoped>
.ratio-card {
  display: flex;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  min-height: 96px;
  height: 100%;

  &__accent {
    width: 6px;
    flex-shrink: 0;
    background: #ababab;
  }

  &--green &__accent {
    background: #005931;
  }

  &--red &__accent {
    background: #d00808;
  }

  &--neutral &__accent {
    background: #ababab;
  }

  &__content {
    flex: 1;
    min-width: 0;
    padding: 12px 14px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
  }

  &__value-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    width: 100%;
    min-width: 0;
    gap: 8px;
  }

  &__value {
    font-family: 'Avenir', sans-serif;
    font-weight: 700;
    font-size: 24px;
    line-height: 1.2;
    white-space: nowrap;
  }

  &--green &__value {
    color: #005931 !important;
  }

  &--red &__value {
    color: #d00808 !important;
  }

  &--neutral &__value {
    color: #ababab !important;
  }

  &__chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    border-radius: 999px;
    background: #e8f5ee;
    color: #005931 !important;
    font-family: 'Avenir', sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.4;
    white-space: nowrap;
  }

  &__star {
    flex-shrink: 0;
    margin-top: 2px;
    color: #005931 !important;
  }

  &__footer {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 8px;
    margin-top: 10px;
  }

  &__label {
    margin: 0;
    font-family: 'Avenir', sans-serif;
    font-size: 14px;
    line-height: 1.3;
    color: #ababab;
  }

  &__info {
    flex-shrink: 0;
    color: #ababab !important;
    cursor: pointer;
  }
}

.theme--dark {
  .ratio-card {
    background: #232830;
    border-color: #3a3f47;

    &--green &__value {
      color: #005931 !important;
    }

    &--red &__value {
      color: #d00808 !important;
    }

    &--neutral &__value {
      color: #ababab !important;
    }

    &__label,
    &__info {
      color: #ababab !important;
    }

    &__chip {
      background: rgba(0, 89, 49, 0.2);
      color: #7fd4a8;
    }
  }
}
</style>
